import Modal from "~/common/components/Modal";
import { useAddToCartWizardContext } from "~/features/addToCart/components/AddToCartProcess/AddToCartWizard";

export const LoadingModal = () => {
  const { closePopup, getModalProps } = useAddToCartWizardContext();

  return <Modal isLoading={true} onClose={() => closePopup()} {...getModalProps()} />;
};
